import { TableFilter } from '/@/modules/core/table/models/TableFilter';
import { SortOrder } from '/@/modules/core/app/constants/SortOrder';

export class TableParam {
  /**
   * @var {number}
   */
  page;

  /**
   * @var {null|string}
   */
  sortField;

  /**
   * @var {string}
   */
  sortOrder;

  /**
   * @var {TableFilter[]}
   */
  selectedTableFilters;

  /**
   * @var {string}
   */
  ownershipFilter;

  constructor(model = {}) {
    this.page = model.page ?? 1;
    this.sortField = model.sortField;
    this.sortOrder = model.sortOrder ?? SortOrder.ASC;
    this.selectedTableFilters = TableFilter.mapModels(model.selectedTableFilters);
    this.ownershipFilter = model.ownershipFilter;
  }
}
